import { render, staticRenderFns } from "./LooxHome.vue?vue&type=template&id=ac59a0d0&scoped=true&"
import script from "./LooxHome.vue?vue&type=script&lang=js&"
export * from "./LooxHome.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ac59a0d0",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/sivaram/work/carthike/whatsapp-crm-client/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('ac59a0d0')) {
      api.createRecord('ac59a0d0', component.options)
    } else {
      api.reload('ac59a0d0', component.options)
    }
    module.hot.accept("./LooxHome.vue?vue&type=template&id=ac59a0d0&scoped=true&", function () {
      api.rerender('ac59a0d0', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/Integrations/loox/LooxHome.vue"
export default component.exports